export default __webpack_public_path__ + "static/media/DownloadConfigFileforUpload-MariaDB.9bd44188.png";